function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 34.8773,
  fill: "none",
  stroke: "#03da8c",
  strokeWidth: 1
}, React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "2.1739130434782608s",
  values: "0;38",
  keyTimes: "0;1",
  keySplines: "0 0.2 0.8 1",
  calcMode: "spline",
  begin: "-1.0869565217391304s"
}), React.createElement("animate", {
  attributeName: "opacity",
  repeatCount: "indefinite",
  dur: "2.1739130434782608s",
  values: "1;0",
  keyTimes: "0;1",
  keySplines: "0.2 0 0.8 1",
  calcMode: "spline",
  begin: "-1.0869565217391304s"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 17.8387,
  fill: "none",
  stroke: "#03da8c",
  strokeWidth: 1
}, React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "2.1739130434782608s",
  values: "0;38",
  keyTimes: "0;1",
  keySplines: "0 0.2 0.8 1",
  calcMode: "spline"
}), React.createElement("animate", {
  attributeName: "opacity",
  repeatCount: "indefinite",
  dur: "2.1739130434782608s",
  values: "1;0",
  keyTimes: "0;1",
  keySplines: "0.2 0 0.8 1",
  calcMode: "spline"
}));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "201px",
    height: "201px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.3da1fdbb.svg";
export { ForwardRef as ReactComponent };